import React from "react";
import { Link, useNavigate } from "react-router-dom";
import PciDssCertified from "../images/brandLogos/pci-dss-certified.png";

export default function Footer() {
  const navigate = useNavigate();
  return (
    <>
      <footer className="h-fit pt-7 sm:pt-6 pb-7 sm:pb-12 grid grid-cols-8 lg:grid-cols-12 gap-x-[18px] mx-7 sm:mx-16">
        {/* Logo Section */}
        <section className="col-span-2 lg:col-span-3 hidden sm:flex justify-center pt-0 lg:pt-10">
          <div
            className="ml-0 sm:-ml-4 lg:-ml-5 justify-self-center cursor-pointer border border-black shadow-[4px_4px_0_black] w-fit h-fit"
            onClick={() => navigate("/")}
          >
            <img
              src="https://cdn.strabl.com/logo/SVG/180x180_logo1.svg"
              width={180}
              height={180}
              alt="Strabl logo"
              className="w-32 lg:w-44 h-10 lg:h-14 object-cover"
            />
          </div>
        </section>
        {/* Useful Links Section */}
        <section className="col-span-full sm:col-span-2 lg:col-span-2 flex flex-col gap-y-3 sm:gap-y-1.5 lg:gap-y-2">
          <h3 className="mb-4 sm:mb-1 lg:mb-4 text-lg sm:text-base lg:text-lg font-gtAmericaBold leading-tight text-black">
            Useful Links
          </h3>
          <Link
            to="/privacy-policy.pdf"
            target="_blank"
            className="text-sm sm:text-xs lg:text-sm font-gtAmericaMedium text-black"
          >
            Privacy Policy{" "}
          </Link>
          <Link
            to="/get-in-touch"
            className="text-sm sm:text-xs lg:text-sm font-gtAmericaMedium text-black"
          >
            Partner with us
          </Link>
          <a
            href="https://forms.fillout.com/t/gM3KTnEim2us"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm sm:text-xs lg:text-sm font-gtAmericaMedium text-black"
          >
            Get STRABL
          </a>
          <a
            href="https://status.strabl.io"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm sm:text-xs lg:text-sm font-gtAmericaMedium text-black"
          >
            System Status
          </a>
        </section>

        {/* Merchants & Shoppers Links Section */}
        <section className="col-span-full sm:col-span-2 lg:col-span-2 flex flex-col gap-y-3 sm:gap-y-1.5 lg:gap-y-2">
          <h3 className="mt-6 sm:mt-0 mb-4 sm:mb-1 lg:mb-4 text-lg sm:text-base lg:text-lg font-gtAmericaBold leading-tight text-black">
            Merchants
          </h3>
          <Link
            to="/merchant-terms.pdf"
            target="_blank"
            className="text-sm sm:text-xs lg:text-sm font-gtAmericaMedium text-black"
          >
            Merchant terms
          </Link>
          <Link
            to="/merchant-faqs.pdf"
            target="_blank"
            className="text-sm sm:text-xs lg:text-sm font-gtAmericaMedium text-black"
          >
            Merchant FAQs
          </Link>

          <h3 className="mt-6 sm:mt-3 lg:mt-5 mb-4 sm:mb-1 lg:mb-4 text-lg sm:text-base lg:text-lg font-gtAmericaBold leading-tight text-black">
            Shoppers
          </h3>
          <Link
            to="/buyer-terms.pdf"
            target="_blank"
            className="text-sm sm:text-xs lg:text-sm font-gtAmericaMedium text-black"
          >
            Shoppers terms
          </Link>
          <Link
            to="/shoppers-faqs.pdf"
            target="_blank"
            className="text-sm sm:text-xs lg:text-sm font-gtAmericaMedium text-black"
          >
            Shoppers FAQs
          </Link>
        </section>

        {/* Contact Section */}
        <section className="mt-6 sm:mt-0 col-span-full sm:col-span-2 lg:col-span-2 flex flex-col gap-y-3.5 sm:gap-y-1.5 lg:gap-y-3.5">
          <h3 className="mb-2 sm:mb-1 lg:mb-4 text-lg sm:text-base lg:text-lg font-gtAmericaBold leading-tight text-black">
            Contact
          </h3>
          <ul className="list-none flex flex-col gap-y-3.5 sm:gap-y-1.5 lg:gap-y-3.5">
            <li className="flex items-start gap-1.5 text-sm sm:text-xs lg:text-sm font-gtAmericaMedium text-black">
              <svg
                width="12"
                height="16"
                viewBox="0 0 10 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mt-0.5"
              >
                <path
                  d="M9.03895 3.03684C8.25315 1.73615 6.85739 0.941507 5.30527 0.911139C5.23902 0.909829 5.17233 0.909829 5.10605 0.911139C3.55396 0.941507 2.1582 1.73615 1.37237 3.03684C0.56914 4.36634 0.547164 5.96334 1.31357 7.30883L4.52435 12.9455C4.52579 12.948 4.52723 12.9505 4.52872 12.953C4.66999 13.1885 4.92306 13.3291 5.20571 13.3291C5.48834 13.3291 5.74141 13.1885 5.88265 12.953C5.88414 12.9505 5.88558 12.948 5.88702 12.9455L9.0978 7.30883C9.86416 5.96334 9.84218 4.36634 9.03895 3.03684ZM5.20566 6.5375C4.20166 6.5375 3.38485 5.75406 3.38485 4.79109C3.38485 3.82811 4.20166 3.04467 5.20566 3.04467C6.20966 3.04467 7.02647 3.82811 7.02647 4.79109C7.02647 5.75406 6.20969 6.5375 5.20566 6.5375Z"
                  fill="#9B03D0"
                />
              </svg>
              Container 7, In5
              <br />
              Dubai Design District,
              <br />
              Dubai, UAE
            </li>
            <li className="flex items-center gap-1.5 text-sm sm:text-xs lg:text-sm font-gtAmericaMedium text-black leading-tight">
              <svg
                width="16"
                height="15"
                viewBox="0 0 14 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="-mt-0.5"
              >
                <path
                  d="M11.7313 10.483L11.7172 10.3308C11.6824 9.97494 11.3506 9.54256 10.9792 9.3698L9.60535 8.72797C9.23266 8.55429 8.62631 8.55832 8.2614 8.74206L7.59578 9.07724C5.78728 8.23783 4.64423 6.65263 4.60176 4.92474L5.2674 4.58956C5.63232 4.4058 5.91969 3.96033 5.91007 3.60382L5.87386 2.28841C5.86406 1.93252 5.56086 1.48521 5.201 1.29463L5.0468 1.2125C4.68618 1.02176 4.09283 1.01612 3.72794 1.19986L2.73206 1.70185C2.55436 1.7908 2.3627 2.1108 2.36233 2.11204C1.70625 4.22304 2.09428 6.46829 3.44174 8.33695C4.7859 10.201 6.97129 11.5337 9.50234 12.0393C9.51557 12.042 9.95509 12.0536 10.1328 11.9646L11.1285 11.4633C11.4934 11.2795 11.7646 10.8385 11.7313 10.483Z"
                  fill="#9B03D0"
                />
                <path
                  d="M11.7313 10.483L11.7172 10.3308C11.6824 9.97494 11.3506 9.54256 10.9792 9.3698L9.60535 8.72797C9.23266 8.55429 8.62631 8.55832 8.2614 8.74206L7.59578 9.07724C5.78728 8.23783 4.64423 6.65263 4.60176 4.92474L5.2674 4.58956C5.63232 4.4058 5.91969 3.96033 5.91007 3.60382L5.87386 2.28841C5.86406 1.93252 5.56086 1.48521 5.201 1.29463L5.0468 1.2125C4.68618 1.02176 4.09283 1.01612 3.72794 1.19986L2.73206 1.70185C2.55436 1.7908 2.3627 2.1108 2.36233 2.11204C1.70625 4.22304 2.09428 6.46829 3.44174 8.33695C4.7859 10.201 6.97129 11.5337 9.50234 12.0393C9.51557 12.042 9.95509 12.0536 10.1328 11.9646L11.1285 11.4633C11.4934 11.2795 11.7646 10.8385 11.7313 10.483Z"
                  fill="#9B03D0"
                />
              </svg>

              <a href="tel:+971545137675" aria-label="Call Strabl">
                +971 54 513 7675
              </a>
            </li>

            <li className="flex items-center gap-1.5 text-sm sm:text-xs lg:text-sm font-gtAmericaMedium text-black leading-tight">
              <svg
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="min-w-[15px]"
              >
                <path
                  d="M12.5001 2.5H2.50006C1.81256 2.5 1.25631 3.0625 1.25631 3.75L1.25006 11.25C1.25006 11.9375 1.81256 12.5 2.50006 12.5H12.5001C13.1876 12.5 13.7501 11.9375 13.7501 11.25V3.75C13.7501 3.0625 13.1876 2.5 12.5001 2.5ZM12.5001 5L7.50006 8.125L2.50006 5V3.75L7.50006 6.875L12.5001 3.75V5Z"
                  fill="#9B03D0"
                />
              </svg>

              <a href="mailto:support@strabl.com" aria-label="Email Strabl">
                support@strabl.com
              </a>
            </li>
            {/* Social Links Section for Tablet Design */}
            <section className="hidden sm:flex lg:hidden flex-col items-start mt-4">
              <section>
                <h3 className="mb-4 text-base font-gtAmericaBold leading-tight text-black">
                  Social Links
                </h3>

                <section className="mt-3.5 flex items-center gap-x-2">
                  {/* Facebook  */}
                  <li className="w-fit flex items-start gap-2 bg-[#9B03D0] border border-black rounded-full py-1.5 px-1.5 drop-shadow-[3px_4px_0_rgba(14,38,36,1)]">
                    <a
                      href="https://www.facebook.com/strabl.checkout"
                      target="_blank"
                      rel="noreferrer"
                      aria-label="Facebook"
                    >
                      <svg
                        width="14"
                        height="13"
                        viewBox="0 0 14 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.625 6.84972C0.625728 9.91235 2.85278 12.5201 5.87757 13V8.64892H4.29811V6.84972H5.87944V5.48012C5.80872 4.83112 6.03041 4.18432 6.48432 3.71512C6.93823 3.24592 7.57735 3.00296 8.22836 3.05213C8.69559 3.05968 9.16164 3.10129 9.6229 3.17665V4.70752H8.83598C8.56504 4.67204 8.29267 4.76151 8.09557 4.95073C7.89847 5.13996 7.79799 5.40845 7.82245 5.68056V6.84972H9.54757L9.27177 8.64955H7.82245V13C11.0936 12.483 13.3875 9.49548 13.0423 6.2017C12.697 2.90793 9.83345 0.460989 6.52616 0.633594C3.21881 0.806199 0.625529 3.53792 0.625 6.84972Z"
                          fill="white"
                        />
                      </svg>
                    </a>
                  </li>
                  {/* Instagram  */}
                  <li className="w-fit flex items-start gap-2 bg-[#9B03D0] border border-black rounded-full py-1.5 px-1.5 drop-shadow-[3px_4px_0_rgba(14,38,36,1)]">
                    <a
                      href="https://www.instagram.com/strabl_checkout"
                      target="_blank"
                      rel="noreferrer"
                      aria-label="Instagram"
                    >
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.80018 13C5.11227 13 4.9133 12.9911 4.25462 12.9623C3.74096 12.9454 3.23396 12.841 2.75543 12.6535C1.92748 12.3313 1.2728 11.6764 0.950911 10.8483C0.770672 10.368 0.673454 9.86062 0.663423 9.34774C0.625 8.69043 0.625 8.47499 0.625 6.80015C0.625 5.10747 0.63392 4.90987 0.663423 4.25462C0.673674 3.74244 0.770884 3.23572 0.950911 2.75611C1.27245 1.92695 1.9282 1.27146 2.75748 0.950225C3.23685 0.769231 3.74369 0.67176 4.25599 0.662051C4.91124 0.625 5.12668 0.625 6.80018 0.625C8.50178 0.625 8.69733 0.63392 9.34572 0.662051C9.85928 0.671842 10.3675 0.7693 10.8483 0.950225C11.6774 1.27182 12.333 1.92719 12.6549 2.75611C12.8382 3.24271 12.9359 3.75735 12.9438 4.27726C12.9822 4.93457 12.9822 5.14933 12.9822 6.82348C12.9822 8.49763 12.9726 8.71719 12.9438 9.36695C12.9335 9.88031 12.836 10.3882 12.6556 10.8689C12.3328 11.6975 11.6772 12.3527 10.8483 12.6748C10.3682 12.8547 9.86107 12.9519 9.34846 12.9623C8.69321 13 8.47845 13 6.80018 13ZM6.77686 1.71114C5.09855 1.71114 4.92428 1.71937 4.26902 1.74888C3.87792 1.75406 3.4906 1.82624 3.12388 1.96226C2.58236 2.16948 2.15385 2.59624 1.94442 3.13691C1.80735 3.50763 1.73516 3.89919 1.73104 4.29441C1.69467 4.95927 1.69467 5.13355 1.69467 6.80015C1.69467 8.44686 1.70085 8.64652 1.73104 9.30726C1.73719 9.69849 1.80933 10.0859 1.94442 10.4531C2.15416 10.9934 2.58259 11.4198 3.12388 11.6271C3.49035 11.764 3.87783 11.8362 4.26902 11.8404C4.9332 11.8789 5.10816 11.8789 6.77686 11.8789C8.45993 11.8789 8.6342 11.8706 9.28397 11.8404C9.67533 11.8357 10.0629 11.7635 10.4298 11.6271C10.968 11.4181 11.3937 10.9926 11.6031 10.4545C11.7399 10.0835 11.812 9.6917 11.8165 9.29628H11.824C11.8535 8.64034 11.8535 8.46538 11.8535 6.78917C11.8535 5.11297 11.846 4.93663 11.8165 4.28137C11.8103 3.8906 11.7381 3.50366 11.6031 3.13691C11.3942 2.59802 10.9684 2.17174 10.4298 1.96226C10.063 1.82555 9.67533 1.75336 9.28397 1.74888C8.62048 1.71114 8.44689 1.71114 6.77686 1.71114ZM6.80018 9.96937C5.51706 9.9702 4.35988 9.19796 3.86824 8.01288C3.37658 6.82773 3.64733 5.46309 4.5542 4.55546C5.46107 3.6478 6.82543 3.37588 8.01099 3.8665C9.19655 4.35712 9.96975 5.51366 9.97009 6.79672C9.96817 8.5471 8.5505 9.96594 6.80018 9.96937ZM6.80018 4.73696C5.66334 4.73696 4.74177 5.65857 4.74177 6.79535C4.74177 7.93219 5.66334 8.85373 6.80018 8.85373C7.93696 8.85373 8.85857 7.93219 8.85857 6.79535C8.85589 5.6596 7.93586 4.73961 6.80018 4.73696ZM10.0936 4.24776C9.68563 4.24625 9.35594 3.9147 9.3567 3.50674C9.35745 3.09879 9.68837 2.76847 10.0963 2.76847C10.5042 2.76847 10.8352 3.09878 10.836 3.50674C10.8361 3.70357 10.7579 3.89236 10.6186 4.0314C10.4793 4.17046 10.2904 4.2483 10.0936 4.24776Z"
                          fill="white"
                        />
                      </svg>
                    </a>
                  </li>
                  {/* Twitter  */}
                  <li className="w-fit flex items-start gap-2 bg-[#9B03D0] border border-black rounded-full py-1.5 px-1.5 drop-shadow-[3px_4px_0_rgba(14,38,36,1)]">
                    <a
                      href="https://twitter.com/STRABL_TNBL"
                      target="_blank"
                      rel="noreferrer"
                      aria-label="Twitter"
                    >
                      <svg
                        width="13"
                        height="11"
                        viewBox="0 0 13 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.5423 1.71001C12.0726 1.39296 12.4695 0.893746 12.6586 0.305557C12.1603 0.601237 11.6151 0.809526 11.0465 0.921409C10.2583 0.0875715 9.00939 -0.115352 7.9977 0.426036C6.98601 0.967423 6.46197 2.11909 6.71843 3.23751C4.6772 3.13503 2.77543 2.17081 1.48636 0.584791C0.813625 1.74516 1.15741 3.2285 2.272 3.97464C1.86896 3.96169 1.47484 3.85254 1.12253 3.65636C1.12253 3.66701 1.12253 3.67766 1.12253 3.68831C1.12276 4.897 1.97465 5.93821 3.1594 6.17775C2.78555 6.27944 2.3934 6.29441 2.01289 6.22153C2.34607 7.25522 3.29875 7.96336 4.38459 7.98448C3.48527 8.69032 2.37463 9.07314 1.23139 9.07125C1.02875 9.07154 0.826267 9.05989 0.625 9.03634C1.78594 9.78235 3.13714 10.1783 4.51711 10.1769C6.43701 10.1901 8.28202 9.43324 9.63955 8.07559C10.9971 6.71793 11.7539 4.87281 11.7405 2.95295C11.7405 2.84291 11.7379 2.73347 11.7328 2.62461C12.23 2.26528 12.6591 1.82013 13 1.31009C12.5368 1.51541 12.0455 1.65021 11.5423 1.71001Z"
                          fill="white"
                        />
                      </svg>
                    </a>
                  </li>
                  {/* LinkedIn  */}
                  <li className="w-fit flex items-start gap-2 bg-[#9B03D0] border border-black rounded-full py-1.5 px-1.5 drop-shadow-[3px_4px_0_rgba(14,38,36,1)]">
                    <a
                      href="https://www.linkedin.com/company/strabl"
                      target="_blank"
                      rel="noreferrer"
                      aria-label="LinkedIn"
                    >
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.8778 13H1.74656C1.12718 12.9992 0.625378 12.4971 0.625 11.8778V1.74656C0.625757 1.12745 1.12745 0.625757 1.74656 0.625H11.8771C12.4964 0.625757 12.9985 1.12723 13 1.74656V11.8778C12.9992 12.4972 12.4972 12.9992 11.8778 13ZM3.14678 5.20894L2.87981 6.1929H3.75917L3.19082 8.50896C3.14905 8.69212 3.126 8.87907 3.12201 9.06698C3.09003 9.36925 3.19822 9.6696 3.41567 9.88207C3.63311 10.0945 3.93586 10.1958 4.23738 10.1569C4.87712 10.1291 5.45178 9.75739 5.73947 9.18533L5.51447 10.0798H6.76056L7.47134 7.23052C7.65024 6.50116 8.00253 6.1296 8.51652 6.1296C8.69914 6.11598 8.87852 6.1832 9.00712 6.31359C9.13579 6.44391 9.20067 6.62419 9.18464 6.80667C9.18643 6.94215 9.16668 7.07708 9.12616 7.20644L8.76285 8.5179C8.71042 8.69948 8.684 8.8876 8.68441 9.07661C8.66473 9.37847 8.78026 9.67352 8.99976 9.88166C9.21925 10.0899 9.51994 10.1897 9.82042 10.1541C10.5291 10.1541 11.0232 9.67248 11.2908 8.72226L10.8044 8.53441C10.6145 9.0773 10.4122 9.34152 10.1851 9.34152C10.0193 9.34152 9.93189 9.22661 9.93189 9.0085C9.9365 8.89407 9.95384 8.78054 9.98349 8.66996L10.3413 7.39153C10.4224 7.12848 10.4641 6.85483 10.4651 6.5796C10.506 6.21382 10.3909 5.8477 10.1479 5.57123C9.90498 5.29474 9.55675 5.13349 9.18877 5.12705C8.46753 5.22555 7.84483 5.6816 7.53327 6.33946L7.78098 5.22683H5.86263L5.59359 6.19015H6.48396L5.9335 8.38373C5.74125 8.92262 5.24787 9.29625 4.67706 9.33533C4.65585 9.33561 4.63466 9.33402 4.61375 9.33051C4.44655 9.29129 4.34953 9.2273 4.34953 9.01951C4.35343 8.84769 4.37886 8.67712 4.42522 8.51171L5.26192 5.20894H3.14678ZM4.76031 3.03325C4.49236 3.03325 4.24477 3.1762 4.11079 3.40825C3.97682 3.6403 3.97682 3.9262 4.11079 4.15825C4.24477 4.39029 4.49236 4.53325 4.76031 4.53325V4.51605C4.96091 4.51767 5.15405 4.44002 5.2977 4.29999C5.4385 4.16093 5.51722 3.97085 5.51584 3.77293C5.51054 3.36044 5.17282 3.0298 4.76031 3.03325Z"
                          fill="white"
                        />
                      </svg>
                    </a>
                  </li>
                </section>
              </section>
            </section>
          </ul>
        </section>

        {/* Social Links Section */}
        <section className="mt-5 sm:mt-0 col-span-full sm:col-span-2 lg:col-span-3 flex sm:hidden lg:flex flex-col items-start sm:items-center">
          <section>
            <h3 className="mb-4 text-lg font-gtAmericaBold leading-tight text-black">
              Social Links
            </h3>

            <ul className="list-none mt-3.5 flex items-center gap-x-5">
              {/* Facebook  */}
              <li className="w-fit flex items-start gap-2 bg-[#9B03D0] border border-black rounded-full py-2 px-2 drop-shadow-[3px_4px_0_rgba(14,38,36,1)]">
                <a
                  href="https://www.facebook.com/strabl.checkout"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Facebook"
                >
                  <svg
                    width="19"
                    height="19"
                    viewBox="0 0 19 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.203125 9.28085C0.204187 13.7472 3.45197 17.5501 7.86313 18.25V11.9047H5.55974V9.28085H7.86585V7.2835C7.76272 6.33705 8.08602 5.3938 8.74797 4.70955C9.40992 4.0253 10.342 3.67098 11.2914 3.74269C11.9727 3.7537 12.6524 3.81439 13.3251 3.92428V6.1568H12.1775C11.7824 6.10506 11.3851 6.23554 11.0977 6.51149C10.8103 6.78744 10.6637 7.17899 10.6994 7.57581V9.28085H13.2152L12.813 11.9056H10.6994V18.25C15.4699 17.4961 18.8151 13.1392 18.3117 8.33581C17.8082 3.53239 13.6321 -0.0360571 8.80898 0.215658C3.98577 0.467374 0.203897 4.45113 0.203125 9.28085Z"
                      fill="white"
                    />
                  </svg>
                </a>
              </li>
              {/* Instagram  */}
              <li className="w-fit flex items-start gap-2 bg-[#9B03D0] border border-black rounded-full py-2 px-2 drop-shadow-[3px_4px_0_rgba(14,38,36,1)]">
                <a
                  href="https://www.instagram.com/strabl_checkout"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Instagram"
                >
                  <svg
                    width="19"
                    height="19"
                    viewBox="0 0 19 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.2086 18.25C6.74707 18.25 6.45689 18.237 5.49631 18.195C4.74723 18.1704 4.00786 18.0181 3.31 17.7447C2.10258 17.2748 1.14783 16.3197 0.678411 15.1121C0.415563 14.4117 0.273788 13.6717 0.259159 12.9238C0.203125 11.9652 0.203125 11.651 0.203125 9.20855C0.203125 6.74006 0.216133 6.45189 0.259159 5.49631C0.274108 4.74939 0.415873 4.01043 0.678411 3.311C1.14732 2.1018 2.10362 1.14587 3.313 0.677411C4.01207 0.413462 4.75122 0.271316 5.49832 0.257157C6.45389 0.203125 6.76808 0.203125 9.2086 0.203125C11.6901 0.203125 11.9753 0.216133 12.9208 0.257157C13.6698 0.271436 14.4109 0.413562 15.1122 0.677411C16.3212 1.1464 17.2773 2.10215 17.7467 3.311C18.014 4.02063 18.1565 4.77114 18.168 5.52933C18.224 6.48791 18.224 6.80111 18.224 9.24257C18.224 11.684 18.21 12.0042 18.168 12.9518C18.1531 13.7005 18.0109 14.4411 17.7477 15.1421C17.2771 16.3506 16.3209 17.306 15.1122 17.7757C14.4119 18.0381 13.6724 18.1799 12.9248 18.195C11.9693 18.25 11.6561 18.25 9.2086 18.25ZM9.17458 1.78708C6.72706 1.78708 6.4729 1.79909 5.51733 1.84211C4.94697 1.84968 4.38212 1.95493 3.84732 2.1533C3.05761 2.45549 2.4327 3.07786 2.12728 3.86633C1.92738 4.40696 1.82211 4.97798 1.8161 5.55435C1.76306 6.52393 1.76306 6.77809 1.76306 9.20855C1.76306 11.61 1.77207 11.9012 1.8161 12.8648C1.82506 13.4353 1.93027 14.0002 2.12728 14.5358C2.43315 15.3237 3.05795 15.9456 3.84732 16.2478C4.38176 16.4475 4.94683 16.5528 5.51733 16.559C6.48591 16.615 6.74106 16.615 9.17458 16.615C11.6291 16.615 11.8832 16.603 12.8308 16.559C13.4015 16.5521 13.9668 16.4468 14.5018 16.2478C15.2867 15.943 15.9075 15.3225 16.2128 14.5378C16.4123 13.9967 16.5175 13.4254 16.524 12.8487H16.535C16.578 11.8922 16.578 11.637 16.578 9.19254C16.578 6.74808 16.567 6.49091 16.524 5.53534C16.515 4.96545 16.4097 4.40117 16.2128 3.86633C15.9082 3.08044 15.2873 2.45878 14.5018 2.1533C13.9669 1.95393 13.4015 1.84865 12.8308 1.84211C11.8632 1.78708 11.61 1.78708 9.17458 1.78708ZM9.2086 13.8303C7.33737 13.8315 5.64983 12.7054 4.93284 10.9771C4.21585 9.24878 4.61069 7.25868 5.93321 5.93505C7.25573 4.61138 9.24542 4.21482 10.9744 4.93031C12.7033 5.6458 13.8309 7.33242 13.8314 9.20355C13.8286 11.7562 11.7611 13.8253 9.2086 13.8303ZM9.2086 6.19974C7.5507 6.19974 6.20674 7.54375 6.20674 9.20155C6.20674 10.8594 7.5507 12.2034 9.2086 12.2034C10.8664 12.2034 12.2104 10.8594 12.2104 9.20155C12.2065 7.54525 10.8648 6.20359 9.2086 6.19974ZM14.0115 5.48632C13.4165 5.48411 12.9357 5.00061 12.9368 4.40567C12.9379 3.81073 13.4205 3.32902 14.0155 3.32902C14.6104 3.32902 15.0929 3.81072 15.0941 4.40566C15.0943 4.6927 14.9803 4.96803 14.7772 5.1708C14.574 5.37358 14.2985 5.48711 14.0115 5.48632Z"
                      fill="white"
                    />
                  </svg>
                </a>
              </li>
              {/* Twitter  */}
              <li className="w-fit flex items-start gap-2 bg-[#9B03D0] border border-black rounded-full py-2 px-2 drop-shadow-[3px_4px_0_rgba(14,38,36,1)]">
                <a
                  href="https://twitter.com/STRABL_Checkout"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Twitter"
                >
                  <svg
                    width="19"
                    height="16"
                    viewBox="0 0 19 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.1242 2.70209C16.8976 2.23974 17.4763 1.51171 17.7522 0.653937C17.0255 1.08514 16.2303 1.38889 15.4012 1.55205C14.2517 0.336042 12.4304 0.0401118 10.955 0.829635C9.4796 1.61916 8.71538 3.29867 9.08938 4.9297C6.11258 4.78025 3.33917 3.37409 1.45928 1.06115C0.478203 2.75336 0.979552 4.91657 2.60501 6.00469C2.01723 5.98579 1.44247 5.82662 0.928693 5.54052C0.928693 5.55605 0.928693 5.57159 0.928693 5.58712C0.92903 7.34979 2.17136 8.86822 3.89912 9.21755C3.35392 9.36585 2.78204 9.38768 2.22712 9.28139C2.71302 10.7889 4.10234 11.8216 5.68587 11.8524C4.37435 12.8817 2.75467 13.44 1.08744 13.4372C0.791922 13.4377 0.496639 13.4207 0.203125 13.3863C1.89617 14.4743 3.86666 15.0517 5.87912 15.0497C8.67897 15.0689 11.3696 13.9651 13.3494 11.9852C15.3291 10.0053 16.4327 7.31451 16.4132 4.51472C16.4132 4.35425 16.4095 4.19464 16.402 4.0359C17.1271 3.51186 17.7529 2.86269 18.25 2.11888C17.5745 2.4183 16.858 2.61489 16.1242 2.70209Z"
                      fill="white"
                    />
                  </svg>
                </a>
              </li>
              {/* LinkedIn  */}
              <li className="w-fit flex items-start gap-2 bg-[#9B03D0] border border-black rounded-full py-2 px-2 drop-shadow-[3px_4px_0_rgba(14,38,36,1)]">
                <a
                  href="https://www.linkedin.com/company/strabl"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="LinkedIn"
                >
                  <svg
                    width="19"
                    height="19"
                    viewBox="0 0 19 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.6134 18.25H1.83873C0.935474 18.2489 0.203677 17.5166 0.203125 16.6134V1.83873C0.204229 0.935866 0.935866 0.204229 1.83873 0.203125H16.6124C17.5156 0.204229 18.2478 0.935545 18.25 1.83873V16.6134C18.2489 17.5168 17.5168 18.2489 16.6134 18.25ZM3.88073 6.88803L3.49139 8.32299H4.77379L3.94495 11.7006C3.88404 11.9677 3.85041 12.2403 3.8446 12.5143C3.79796 12.9552 3.95574 13.3932 4.27285 13.703C4.58995 14.0129 5.03147 14.1606 5.47118 14.1038C6.40413 14.0633 7.24218 13.5212 7.66172 12.6869L7.3336 13.9914H9.15082L10.1874 9.83617C10.4483 8.77253 10.962 8.23067 11.7116 8.23067C11.9779 8.2108 12.2395 8.30884 12.427 8.49899C12.6147 8.68904 12.7093 8.95194 12.6859 9.21805C12.6885 9.41563 12.6597 9.61241 12.6006 9.80105L12.0708 11.7136C11.9944 11.9784 11.9558 12.2528 11.9564 12.5284C11.9277 12.9686 12.0962 13.3989 12.4163 13.7024C12.7364 14.0061 13.1749 14.1517 13.6131 14.0998C14.6467 14.0998 15.3671 13.3974 15.7575 12.0116L15.048 11.7377C14.7711 12.5294 14.4761 12.9147 14.1449 12.9147C13.9031 12.9147 13.7757 12.7471 13.7757 12.4291C13.7824 12.2622 13.8077 12.0966 13.8509 11.9354L14.3727 10.071C14.491 9.68736 14.5518 9.28829 14.5533 8.88692C14.6129 8.35349 14.4451 7.81956 14.0908 7.41638C13.7364 7.01317 13.2286 6.778 12.692 6.76862C11.6402 6.91226 10.732 7.57733 10.2777 8.53672L10.6389 6.91412H7.84134L7.44899 8.31897H8.74744L7.94469 11.5179C7.66433 12.3038 6.94482 12.8487 6.11237 12.9057C6.08145 12.9061 6.05055 12.9038 6.02006 12.8987C5.77622 12.8415 5.63474 12.7482 5.63474 12.4451C5.64042 12.1946 5.6775 11.9458 5.74511 11.7046L6.9653 6.88803H3.88073ZM6.23379 3.71516C5.84303 3.71516 5.48195 3.92362 5.28657 4.26203C5.09119 4.60043 5.09119 5.01737 5.28657 5.35578C5.48195 5.69418 5.84303 5.90265 6.23379 5.90265V5.87757C6.52633 5.87994 6.80799 5.7667 7.01747 5.56249C7.22282 5.35968 7.33761 5.08248 7.3356 4.79385C7.32788 4.1923 6.83536 3.71013 6.23379 3.71516Z"
                      fill="white"
                    />
                  </svg>
                </a>
              </li>
            </ul>
          </section>
          <section className="mt-7">
            <h3 className="text-lg font-gtAmericaBold leading-tight text-black">
              Security & Compliance
            </h3>

            <img
              src={PciDssCertified}
              alt="PCI DSS Certified"
              className="w-20 sm:w-16 mt-3.5"
            />
          </section>
        </section>
      </footer>

      <div className="bg-black text-white py-5 sm:py-4 flex flex-col sm:flex-row items-center justify-center gap-1.5">
        <p className="text-center text-sm font-gtAmericaBold leading-tight">
          A company of Blob Tech Holdings LTD.{" "}
          <span className="hidden sm:inline">|</span>{" "}
        </p>{" "}
        <p className="text-center text-sm font-gtAmericaBold leading-tight">
          {" "}
          © Copyright {new Date().getFullYear()} All Right Reserved
        </p>
      </div>
    </>
  );
}
